import { Routes, Route, Navigate } from 'react-router-dom';
import { useGet2ndLevelPageUrl } from 'app-level/navigation';
import { useFeatureFlag, useFeatureFlagsLoaded } from 'context/FeatureFlagContext';
import LoanRemittanceProfile from './LoanRemittanceProfile';
import { RemittanceTapeDealTable } from './RemittanceTapeDealTable';
import { RemittanceHomePage } from './RemittanceHomePage';
import { RemittanceCashFlow } from './RemittanceCashFlow';

const REMITTANCE_TAB_SERVICED = 'serviced-deals';
const REMITTANCE_TAB_UPLOAD = 'upload-history';

const RemittanceContainer = () => {
  const getUrl = useGet2ndLevelPageUrl();
  const isRemittanceEnabled = useFeatureFlag('remittance');
  const flagsLoaded = useFeatureFlagsLoaded();

  // Hold rendering until flags settle; otherwise a cold bookmark to
  // /portfolio/remittance/* redirects to dashboard before the flag query lands.
  if (!flagsLoaded) {
    return null;
  }

  if (!isRemittanceEnabled) {
    return <Navigate to={`/portfolio/${getUrl('portfolio', 'dashboard')}`} replace />;
  }

  return (
    <Routes>
      <Route index element={<Navigate to={REMITTANCE_TAB_SERVICED} replace />} />
      <Route path={REMITTANCE_TAB_SERVICED} element={<RemittanceHomePage />} />
      <Route path={REMITTANCE_TAB_UPLOAD} element={<RemittanceHomePage />} />
      {/* Specific paths first so "dealId/..." is not matched by /:dealId */}
      <Route path="dealId/:dealId" element={<RemittanceTapeDealTable />} />
      <Route path="dealId/:dealId/uploadId/:uploadId" element={<RemittanceTapeDealTable />} />
      <Route path="dealId/:dealId/cashflow" element={<RemittanceCashFlow />} />
      <Route path="dealId/:dealId/accountId/:accountId" element={<LoanRemittanceProfile />} />
      <Route path="accountId/:accountId" element={<LoanRemittanceProfile />} />
      <Route path=":dealId" element={<RemittanceHomePage />} />
    </Routes>
  );
};

export default RemittanceContainer;
